import { GridRenderCellParams } from "@mui/x-data-grid";

export const ViewClaimsColumnsMetaData = {
  columns: [
      {
          headerName: "Claim ID",
          mappedValue: "id",
          width: 160,
          headerAlign: "left",
          align: "left",
      },
      {
          headerName: "Claim Date",
          mappedValue: "claimDate",
          width: 120,
          headerAlign: "left",
          align: "left",
      },
      {
          headerName: "Approval Date",
          mappedValue: "approvalDate",
          width: 130,
          headerAlign: "left",
          align: "left",
      },
      {
          headerName: "Claim Type",
          mappedValue: "claimType",
          width: 250,
          headerAlign: "left",
          align: "left",
          type: "order",
      },
      {
          headerName: "Claim Month",
          mappedValue: "claimMonth",
          width: 120,
          headerAlign: "left",
          align: "left",
      },
      {
          headerName: "Claim Amount",
          mappedValue: "claimAmount",
          width: 140,
          headerAlign: "left",
          align: "left",
          includeCurrenySymbol:true
      },
      {
          headerName: "Claim Status",
          mappedValue: "status",
          width: 150,
          headerAlign: "left",
          align: "left",
      },
  ],
  Actions: ["view"],
};

export const OpenClaimsColumnsMetaData = {
  columns: [
      {
          headerName: "Claim ID",
          mappedValue: "id",
          width: 170,
          headerAlign: "left",
          align: "left",
      },
      {
          headerName: "Claim Date",
          mappedValue: "claimDate",
          width: 120,
          headerAlign: "left",
          align: "left",
      },
      {
          headerName: "Distributor ID",
          mappedValue: "distributorId",
          width: 130,
          headerAlign: "left",
          align: "left",
      },
      {
          headerName: "Distributor Name",
          mappedValue: "distributorName",
          width: 160,
          headerAlign: "left",
          align: "left",
      },
      {
          headerName: "Claim Type",
          mappedValue: "claimType",
          width: 180,
          headerAlign: "left",
          align: "left",
          type: "order",
      },
      {
        headerName: "Claim Qty",
        mappedValue: "totalCase,totalPcs,totalOthers",
        width: 140,
        headerAlign: "left",
        align: "left",
        includeQty:true,
    },
      {
          headerName: "Claim Amount",
          mappedValue: "claimAmount",
          width: 140,
          headerAlign: "left",
          align: "left",
          includeCurrenySymbol:true
      },
      {
          headerName: "Claim Status",
          mappedValue: "status",
          width: 170,
          headerAlign: "left",
          align: "left",
      },
  ],
  Actions: ["view"],
};

interface ColumnMetaData {
  headerName: string;
  mappedValue: string;
  width: number;
  headerAlign: string;
  align: string;
  type?: string; 
  hasFocIcon?: boolean;
  noHyperlinkStyle?: boolean;
  cellRenderElement?: any;
  headerParts?: {
    top: string;
    bottom: string;
  };
}

export const getClaimsDetailsColumnsMetaData = (
claimType: string,
typeOfExpense: string,
claimTypes: any,
claimSubTypes: any,
path: string,
enableFocPurchaseReturnClaims: boolean = false
) : { columns: ColumnMetaData[]; Actions: string[] } => {
if (claimType === claimTypes[2]) {
  const columns: ColumnMetaData[] = [
    {
      headerName: "Outlet Code",
      mappedValue: "outletCode",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Outlet Name",
      mappedValue: "outletName",
      width: 250,
      headerAlign: "left",
      align: "left",
    },
  ];

  if (typeOfExpense === claimSubTypes[4]) {
    columns.push({
      headerName: "SKU Code & Name",
      mappedValue: "skus",
      width: 250,
      headerAlign: "left",
      align: "left",
    });
  }
  if (path === "closed" && typeOfExpense === claimSubTypes[5]) {
    columns.push(
      {
        headerName: "Asset Qty",
        mappedValue: "assetQty",
        width: 120,
        headerAlign: "left",
        align: "left",
      },
      {
      headerName: "Approved Asset Qty",
      mappedValue: "assetApprovedQty",
      width: 200,
      headerAlign: "left",
      align: "left",
    });
  }
  columns.push({
    headerName: "Claim Amount",
    mappedValue: "claimAmount",
    width: 200,
    headerAlign: "left",
    align: "left",
  });

  if (path === "closed") {
    columns.push({
      headerName: "Approved Claim Amount",
      mappedValue: "approvedClaimAmount",
      width: 240,
      headerAlign: "left",
      align: "left",
    });
  }

  return {
    columns,
    Actions: [],
  };
}

else if (typeOfExpense === claimSubTypes[3]) {
  const columns: ColumnMetaData[] = [
    {
      headerName: "Invoice No.",
      mappedValue: "invoiceNumber",
      width: 180,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Invoice Date & Time",
      mappedValue: "invoiceDateTime",
      width: 240,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Total Qty",
      mappedValue: "damageCases,damagePcs,damageOthers",
      width: 180,
      headerAlign: "left",
      align: "left",
    },
  ];

  if (path === "closed") {
    columns.push({
      headerName: "Approved Qty",
      mappedValue: "approvedCases,approvedPcs,approvedOthers",
      width: 180,
      headerAlign: "left",
      align: "left",
    });
  }

  columns.push({
    headerName: "Claim Amount",
    mappedValue: "claimAmount",
    width: 200,
    headerAlign: "left",
    align: "left",
  });

  if (path === "closed") {
    columns.push(
      {
        headerName: "Approved Claim Amount",
        headerParts: { top: "Approved Claim", bottom: "Amount" },
        mappedValue: "approvedClaimAmount",
        width: 200,
        headerAlign: "left",
        align: "left",
      },
      // {
      //   headerName: "Claim Status",
      //   mappedValue: "status",
      //   width: 200,
      //   headerAlign: "left",
      //   align: "left",
      // }
    );
  }

  columns.push({
    headerName: "",
    mappedValue: "viewClaimsModal",
    width: 100,
    headerAlign: "right",
    align: "right",
    type: "view",
  });

  return {
    columns,
    Actions: [],
  };
}

const columns: ColumnMetaData[] = [
  {
    headerName: "SKU Code",
    mappedValue: "skuCode",
    width: 160,
    headerAlign: "left",
    align: "left",
    hasFocIcon: enableFocPurchaseReturnClaims && (typeOfExpense === claimSubTypes[1])
  },
  {
    headerName: "SKU Name",
    mappedValue: "skuName",
    width: 220,
    headerAlign: "left",
    align: "left",
  },
  {
    headerName: "Total Qty",
    mappedValue: "damageCase,damagePcs,damageOthers",
    width: 190,
    headerAlign: "left",
    align: "left",
  },
];

if (typeOfExpense === claimSubTypes[0]) {
  columns.splice(2, 0, {
    headerName: "Return Order No",
    mappedValue: "returnOrderNo",
    noHyperlinkStyle: true,
    width: 180,
    headerAlign: "left",
    align: "left",
    cellRenderElement: (params: GridRenderCellParams) => (
      <div 
        style={{ 
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "100%"
        }}
        title={params.row.returnOrderNo}
      >
        {params.row.returnOrderNo}
      </div>
    )
  });
}

if (path === "closed") {
  columns.push({
    headerName: "Approved Qty",
    mappedValue: "approvedCase,approvedPcs,approvedOthers",
    width: 190,
    headerAlign: "left",
    align: "left",
  });
}

columns.push({
  headerName: claimType === claimTypes[1] ? "Discount" : "Claim Amount",
  mappedValue: "claimAmount",
  width: 160,
  headerAlign: "left",
  align: "left",
});

if (path === "closed") {
  columns.push({
    headerName: "Approved Claim Amount",
    headerParts: { top: "Approved Claim", bottom: "Amount" },
    mappedValue: "approvedClaimAmount",
    width: 200,
    headerAlign: "left",
    align: "left",
  });
}
return {
  columns,
  Actions: [],
};
};

export const getViewClaimsDetailsColumnsMetaData = (
  claimType: string,
  typeOfExpense: string,
  claimTypes: any,
  claimSubTypes: any,
  enableFocPurchaseReturnClaims: boolean = false
  ) : { columns: ColumnMetaData[]; Actions: string[] } => {
  if (claimType === claimTypes[2]) {
    const columns: ColumnMetaData[] = [
      {
        headerName: "Outlet Code",
        mappedValue: "outletCode",
        width: 200,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "Outlet Name",
        mappedValue: "outletName",
        width: 250,
        headerAlign: "left",
        align: "left",
      },
    ];
  
    if (typeOfExpense === claimSubTypes[4]) {
      columns.push({
        headerName: "SKU Code & Name",
        mappedValue: "skus",
        width: 250,
        headerAlign: "left",
        align: "left",
      }
    );
    }
    if (typeOfExpense === claimSubTypes[5]) {
      columns.push(
        {
          headerName: "Asset Qty",
          mappedValue: "assetQty",
          width: 110,
          headerAlign: "left",
          align: "left",
        },
        {
        headerName: "Approved Asset Qty",
        mappedValue: "assetApprovedQty",
        width: 190,
        headerAlign: "left",
        align: "left",
      });
    }
    columns.push({
      headerName: "Claim Amount",
      mappedValue: "claimAmount",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Approved Claim Amount",
      headerParts: { top: "Approved Claim", bottom: "Amount" },
      mappedValue: "approvedClaimAmount",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "",
      mappedValue: "viewClaimsModal",
      width: 70,
      headerAlign: "right",
      align: "right",
      type: "view"
    }
  );
  
    return {
      columns,
      Actions: [],
    };
  }
  
  else if (typeOfExpense === claimSubTypes[3]) {
    const columns: ColumnMetaData[] = [
      {
        headerName: "Invoice No.",
        mappedValue: "invoiceNumber",
        width: 180,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "Invoice Date & Time",
        mappedValue: "invoiceDateTime",
        width: 240,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "Total Qty",
        mappedValue: "damageCases,damagePcs,damageOthers",
        width: 160,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "Approved Qty",
        mappedValue: "approvedCase,approvedPcs,approvedOthers",
        width: 160,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "Claim Amount",
        mappedValue: "claimAmount",
        width: 200,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "Approved Claim Amount",
        headerParts: { top: "Approved Claim", bottom: "Amount" },
        mappedValue: "approvedClaimAmount",
        width: 200,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "",
        mappedValue: "viewClaimsModal",
        width: 70,
        headerAlign: "right",
        align: "right",
        type: "view"
      }
    ];
  
    return {
      columns,
      Actions: [],
    };
  }
  
  const columns: ColumnMetaData[] = [
    {
      headerName: "SKU Code",
      mappedValue: "skuCode",
      width: 120,
      headerAlign: "left",
      align: "left",
      hasFocIcon: enableFocPurchaseReturnClaims && (typeOfExpense === claimSubTypes[1])
    },
    {
      headerName: "SKU Name",
      mappedValue: "skuName",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Total Qty",
      mappedValue: "damageCase,damagePcs,damageOthers",
      width: 160,
      headerAlign: "left",
      align: "left",
    },
   {
      headerName: "Approved Qty",
      mappedValue: "approvedCase,approvedPcs,approvedOthers",
      width: 160,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Claim Amount",
      mappedValue: "claimAmount",
      width: 160,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Approved Claim Amount",
      headerParts: { top: "Approved Claim", bottom: "Amount" },
      mappedValue: "approvedClaimAmount",
      width: 200,
      headerAlign: "left",
      align: "left",
    }
  ];
  
  if (typeOfExpense === claimSubTypes[0]) {
    columns.splice(2, 0, {
      headerName: "Return Order No",
      mappedValue: "returnOrderNo",
      noHyperlinkStyle: true,
      width: 200,
      headerAlign: "left",
      align: "left",
      cellRenderElement: (params: GridRenderCellParams) => (
        <div 
          style={{ 
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%"
          }}
          title={params.row.returnOrderNo}
        >
          {params.row.returnOrderNo}
        </div>
      )
    });
  }

  return {
    columns,
    Actions: [],
  };
  };